import {
    useEffect,
    useState,
} from 'react';

import {
    useNavigate,
} from 'react-router-dom';

import '../../styles/Admin.css';

import api from '../../api/api';

export default function AdminLogin() {

    const navigate =
        useNavigate();

    useEffect(() => {

        const token =
            localStorage.getItem(
                'authToken'
            ) ||
            sessionStorage.getItem(
                'authToken'
            );

        if (token) {

            navigate(
                '/admin-dashboard',
                {
                    replace: true,
                }
            );

        }

    }, [navigate]);

    const [email, setEmail] =
        useState('');

    const [password, setPassword] =
        useState('');

    const [rememberMe, setRememberMe] =
        useState(true);

    const [loading, setLoading] =
        useState(false);

    const [error, setError] =
        useState('');

    const handleLogin = async (
        e: React.FormEvent
    ) => {

        e.preventDefault();

        setLoading(true);

        setError('');

        try {

            const response =
                await api.post(
                    '/login',
                    {
                        email,
                        password,
                    }
                );

            const {
                token,
                user,
            } = response.data;

            if (rememberMe) {

                localStorage.setItem(
                    'authToken',
                    token
                );

                localStorage.setItem(
                    'authUser',
                    JSON.stringify(
                        user
                    )
                );

            } else {

                sessionStorage.setItem(
                    'authToken',
                    token
                );

                sessionStorage.setItem(
                    'authUser',
                    JSON.stringify(
                        user
                    )
                );

            }

            navigate(
                '/admin-dashboard'
            );

        } catch (err: any) {

            if (
                err.response?.data
                    ?.message
            ) {

                setError(
                    err.response.data
                        .message
                );

            } else {

                setError(
                    'Something went wrong.'
                );

            }

        } finally {

            setLoading(false);

        }
    };

    return (
        <div className="admin-layout">

            <div className="admin-center">

                <div className="login-card">

                    <div className="logo-wrapper">

                        <img
                            src="/denny logo.svg"
                            alt="Logo"
                            className="logo"
                        />

                    </div>

                    <h2>
                        Admin Login
                    </h2>

                    <p>
                        Sign in to access
                        the CMS dashboard
                    </p>

                    {error && (

                        <div className="error-box">
                            {error}
                        </div>

                    )}

                    <form
                        onSubmit={
                            handleLogin
                        }
                        className="login-form"
                    >

                        <label>
                            Email
                        </label>

                        <input
                            type="email"
                            value={email}
                            onChange={(e) =>
                                setEmail(
                                    e.target
                                        .value
                                )
                            }
                            placeholder="admin@example.com"
                            required
                        />

                        <label>
                            Password
                        </label>

                        <input
                            type="password"
                            value={password}
                            onChange={(e) =>
                                setPassword(
                                    e.target
                                        .value
                                )
                            }
                            placeholder="Enter password"
                            required
                        />

                        <div className="login-row">

                            <label
                                style={{
                                    display:
                                        'flex',
                                    alignItems:
                                        'center',
                                    gap: '8px',
                                    marginTop:
                                        0,
                                }}
                            >

                                <input
                                    type="checkbox"
                                    checked={
                                        rememberMe
                                    }
                                    onChange={(
                                        e
                                    ) =>
                                        setRememberMe(
                                            e
                                                .target
                                                .checked
                                        )
                                    }
                                />

                                Remember me

                            </label>

                            <button
                                type="button"
                                className="forgot-btn"
                                onClick={() =>
                                    navigate(
                                        '/forgot-password'
                                    )
                                }
                            >
                                Forgot Password?
                            </button>

                        </div>

                        <button
                            type="submit"
                            disabled={
                                loading
                            }
                            className="login-button"
                        >

                            {loading
                                ? 'Signing in...'
                                : 'Login'}

                        </button>

                    </form>

                </div>

            </div>

        </div>
    );
}
